export default "__VITE_ASSET__BcVGsLHJ__"